import { useState } from 'react';
import { Grid, TextField, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';

export type AutojobType = 'custom' | 'delete' | 'resign' | 'deleteSnapshot' | 'anonymizeSnapshot' | 'setProfile' | 'removeProfile';

// Jobbtyper för ögonblicksbilder – skapas i CreateAutojobForMemberSnapshotModal.
export type SnapshotJobType = Extract<AutojobType, 'deleteSnapshot' | 'anonymizeSnapshot'>;

export const isSnapshotJobType = (jobType: AutojobType): jobType is SnapshotJobType =>
  jobType === 'deleteSnapshot' || jobType === 'anonymizeSnapshot';

export const autojobTypeOptions: { value: AutojobType; labelKey: string }[] = [
  { value: 'custom', labelKey: 'settings:autojobs.jobTypes.custom' },
  { value: 'delete', labelKey: 'settings:autojobs.jobTypes.delete' },
  { value: 'resign', labelKey: 'settings:autojobs.jobTypes.resign' },
  { value: 'deleteSnapshot', labelKey: 'settings:autojobs.jobTypes.deleteSnapshot' },
  { value: 'anonymizeSnapshot', labelKey: 'settings:autojobs.jobTypes.anonymizeSnapshot' },
  { value: 'setProfile', labelKey: 'settings:autojobs.jobTypes.setProfile' },
  { value: 'removeProfile', labelKey: 'settings:autojobs.jobTypes.removeProfile' },
];

type SelectAutojobTypeModalProps = {
  open: boolean;
  onClose: () => void;
  onSelect: (jobType: AutojobType) => void;
};

export const SelectAutojobTypeModal = (props: SelectAutojobTypeModalProps) => {
  const { open, onClose, onSelect } = props;
  const { t } = useTranslation(['settings', 'common']);
  const [jobType, setJobType] = useState<AutojobType>('custom');

  return (
    <GenericDialog
      open={open}
      dialogTitle={t('settings:autojobs.createModal.title')}
      maxWidth='sm'
      onClose={onClose}
      onSave={() => onSelect(jobType)}
      saveLabel='common:button.next'
      abortLabel='common:button.cancel'
      dialogContent={
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label={t('settings:autojobs.selectTypeModal.jobType')}
              value={jobType}
              onChange={(e) => setJobType(e.target.value as AutojobType)}
              fullWidth
              size='small'
              select
            >
              {autojobTypeOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {t(opt.labelKey)}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      }
    />
  );
};
